// extracted by mini-css-extract-plugin
module.exports = {"SectionCard4":"SectionCard4_SectionCard4___cwTn"};